const primary = '#07c'
const secondary = '#80c'
const muted = '#f6f6ff'

export default {
  colors: {
    text: '#fff',
    background:
      '#00356a url(data:image/png;base64,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) center/70% no-repeat',
    primary,
    secondary,
    muted,
  },
  styles: {
    fontFamily: 'system-ui, sans-serif',
    fontWeight: 100,
    fontSize: '16px',
    textAlign: 'center',
    '@media screen and (min-width:736px)': {
      fontSize: '18px',
    },
    '@media screen and (min-width:900px)': {
      fontSize: '24px',
    },
    '@media screen and (min-width:1024px)': {
      fontSize: '30px',
    },
    p: {
      fontSize: '1em',
      margin: '0 0 0.8em 0',
    },
    h1: {
      fontSize: '2em',
      fontWeight: '100',
      lineHeight: 1.125,
      marginTop: 0,
    },
    h2: {
      fontSize: '1.6em',
      fontWeight: '100',
      lineHeight: 1.125,
      marginTop: 0,
    },
    h3: {
      fontSize: '1.3em',
      fontWeight: 'bold',
      lineHeight: 1.125,
      marginTop: 0,
    },
    h4: {
      fontSize: '1.2em',
      fontWeight: 'bold',
      lineHeight: 1.125,
      marginTop: 0,
    },
    h5: {
      fontSize: '1.1em',
      fontWeight: 'bold',
      lineHeight: 1.125,
      marginTop: 0,
    },
    h6: {
      fontSize: '1em',
      fontWeight: 'bold',
      lineHeight: 1.125,
      marginTop: 0,
    },
    a: {
      color: primary,
    },
    ul: {
      margin: '0 0 20px 0',
      textAlign: 'left',
    },
    ol: {
      margin: '0 0 20px 0',
      textAlign: 'left',
    },
    li: {
      marginBottom: 20
    },
    inlineCode: {
      fontFamily: '"Roboto Mono", Menlo, monospace',
    },
    code: {
      fontFamily: '"Roboto Mono", Menlo, monospace',
    },
    pre: {
      fontFamily: '"Roboto Mono", Menlo, monospace',
      padding: 3,
      textAlign: 'left',
      fontSize: '.7em',
    },
    img: {
      maxWidth: '100%',
      height: 'auto',
      objectFit: 'cover',
    },
    table: {
      width: '100%',
      borderCollapse: 'separate',
      borderSpacing: 0,
    },
    th: {
      textAlign: 'left',
      paddingRight: '.5em',
      paddingTop: '.25em',
      paddingBottom: '.25em',
      borderBottom: '1px solid',
      verticalAlign: 'top',
    },
    td: {
      textAlign: 'left',
      paddingRight: '.5em',
      paddingTop: '.25em',
      paddingBottom: '.25em',
      borderBottom: '1px solid',
      verticalAlign: 'top',
    },
    blockquote: {
      fontWeight: 'bold',
    },
  },
}
